import * as React from "react"
const MuteIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={ 15 }
        height={ 15 }
        className="icon"
        viewBox="0 0 1024 1024"
        { ...props }
    >
        <path
            fill="gray"
            d="m241.216 832 63.616-64H768V448c0-42.368-10.24-82.304-28.48-117.504l46.912-47.232C815.36 331.392 832 387.84 832 448v320h96a32 32 0 1 1 0 64H241.216zm-90.24 0H96a32 32 0 1 1 0-64h96V448a320.128 320.128 0 0 1 256-313.6V128a64 64 0 1 1 128 0v6.4a319.552 319.552 0 0 1 171.648 97.088l-45.184 45.44A256 256 0 0 0 256 448v278.336L151.04 832zM448 896h128a64 64 0 0 1-128 0z"
        />
        <path
            fill="gray"
            d="M150.72 859.072a32 32 0 0 1-45.44-45.056l704-708.544a32 32 0 0 1 45.44 45.056l-704 708.544z"
        />
    </svg>
)
export default MuteIcon
